import React from 'react';

import { colorPalette } from '../../../theme';
import { BubbleText } from './BubbleText';

interface Props {
  className?: string;
  name: string;
  color: string | null | undefined;
}

const DefaultPlexNameColor = colorPalette.gray._400;

export function PlexName({ className, name, color }: Props): React.ReactElement {
  return <BubbleText text={`#${name}`} backgroundColor={color || DefaultPlexNameColor} className={className} />;
}
